import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect'

import { PopOut, Button } from 'components'
import { SectionOptions, SectionInput, ToggleButton } from 'features'
import { sectionContext } from 'context';
import { FaAngleUp, FaEllipsisH, FaGripVertical } from 'react-icons/fa';

import { Section } from 'schema'
import * as actionCreators from 'store/actions'
import classes from './SectionBlock.module.css'

const Container = styled.div`
    border-radius: ${props => props.edit ? '5px' : null};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    min-height: 2.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: ${props => !props.edit ? '1px solid var(--primary-accent-color)' : null};
`

const Title = styled.div`
    align-items: center;
    font-weight: bolder;
    font-size: 0.9rem;
    padding-left: 0.5rem;
    word-wrap: break-word;
    color: ${props => props.active ? 'var(--text-color)' : 'var(--secondary-accent-color)'};
    @media not all and (min-resolution:.001dpcm) { 
        -webkit-text-decoration-line: ${props => !props.active ? 'line-through' : null};
    };
    
    @media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm) {
        text-decoration: ${props => !props.active ? 'line-through' : null};
        text-decoration-color: var(--secondary-accent-color);
        // text-decoration-thickness: 1rem; // Will cause issues for Firefox
    };
`

class SectionBlock extends Component {
    constructor(props){
        super(props);
        this.state = {
            hover: false,
        }
    }

    toggleSectionHandler = () => {
        let updatedSection = (({ details, section_items, ...o }) => o)(this.props.section)
        updatedSection['items_visibility'] = !updatedSection['items_visibility']
        this.props.updateSection(new Section(updatedSection), this.props.data, this.props.uid, this.props.sessionId)
    }

    render () {
        const section = new Section(this.props.section);
        const edit = this.props.inputID === `${section['sectionID']}_SectionBlock`
        const showMoreButton = !this.props.disableShowMore & !edit
        const secondaryButtons = 
        <div className={classes.SecondaryButtons}>
            <Button icon={<FaEllipsisH/>} 
                contextMenu={<SectionOptions section={this.props.section}/>} 
                styles={{
                    color:'var(--secondary-accent-color)', 
                    backgroundColor:'var(--primary-color)', 
                    hoverColor:'var(--text-color)', 
                    boxShadowColor: 'transparent',
                    margin:'0', padding:'0.3rem', fontSize:'0.8rem', fontWeight: 'lighter'}}/> 
        </div>

        const mainClass = this.props.type === 'DRAG_OVERLAY' ? classes.DragOverlay : edit ? classes.EditBlock : classes.SectionBlock
        if(this.props.disableOptions){
            return (
                <div className={mainClass}>
                    {!this.props.hideGrip && <div className={classes.DragHandle}><FaGripVertical/></div>}
                    <div className={classes.Container} onClick={!isMobile & showMoreButton ? this.toggleSectionHandler : null}>
                        {(!this.props.disableShowMore & section.gotChildren(this.props.user.showCompleted) & !edit) ? <ToggleButton open={section['items_visibility']} styles={{backgroundColor: 'var(--primary-color)', padding: '0.3rem', fontSize: '1rem'}} icon={<FaAngleUp/>} end={180}/> : null}
                        {edit ? <SectionInput section={this.props.section} type='EDIT' id={`${this.props.section.sectionID}_SectionBlock`}/> 
                        : <Title active={this.props.section.status === sectionContext.STATUS.ACTIVE}>{this.props.section.section_name}</Title>}
                    </div>
                    {/* {this.props.inputID !== `${this.props.section.sectionID}_SectionBlock` ? secondaryButtons : null} */}
                </div>
            )
        } else {
            return (
                <PopOut trigger={isMobile ? 'leftClick' : 'rightClick'} point={true} element={<SectionOptions section={this.props.section}/>}>
                    <div className={mainClass}>
                        {!this.props.hideGrip && <div className={classes.DragHandle}><FaGripVertical/></div>}
                        <div className={classes.Container} onClick={!isMobile & showMoreButton ? this.toggleSectionHandler : null}>
                            {(!this.props.disableShowMore & section.gotChildren(this.props.user.showCompleted) & !edit) ? <ToggleButton open={section['items_visibility']} styles={{backgroundColor: 'var(--primary-color)', padding: '0.3rem', fontSize: '1rem'}} icon={<FaAngleUp/>} end={180}/> : null}
                            {edit ? <SectionInput section={this.props.section} type='EDIT' id={`${this.props.section.sectionID}_SectionBlock`}/> 
                            : <Title active={this.props.section.status === sectionContext.STATUS.ACTIVE}>{this.props.section.section_name}</Title>}
                        </div>
                        {this.props.inputID !== `${this.props.section.sectionID}_SectionBlock` ? secondaryButtons : null}
                    </div>
                </PopOut>
            )
        }
        
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        activePageID: state.auth.activePageID,
        data: state.db.present.data && state.db.present.data.toJS(),
        inputID: state.content.inputID,
        sessionId: state.content.sessionId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateSection: (section, data, userId, sessionId) => dispatch(actionCreators.updateSection(section, data, userId, sessionId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionBlock);

SectionBlock.propTypes = {
    disableShowMore: PropTypes.bool
}